import {
  faCheck,
  faInfo,
  faWarning,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { StyledAlert, StyledFooterAlerts } from "./MainFooterAlertsStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledFlexRow } from "../../../../styles/LayoutStyles";
import { StyledTextButton } from "../../../../styles/ButtonStyles";

function MainFooterAlertsView({ alerts, onHideAlert }) {
  function getAlertIcon(alert) {
    switch (alert.type) {
      case "info":
        return faInfo;
      case "success":
        return faCheck;
      case "error":
        return faWarning;
      default:
        return faInfo;
    }
  }

  return (
    <StyledFooterAlerts>
      {alerts.map((alert) => (
        <StyledAlert key={alert.uuid}>
          <StyledFlexRow
            style={{
              flex: 1,
              flexWrap: "nowrap",
              alignItems: "center",
            }}
          >
            <FontAwesomeIcon icon={getAlertIcon(alert)} />

            <p style={{ flex: 1, maxWidth: "450px" }}>{alert.message}</p>
          </StyledFlexRow>

          <StyledTextButton onClick={() => onHideAlert(alert)}>
            <FontAwesomeIcon icon={faXmark} />
          </StyledTextButton>
        </StyledAlert>
      ))}
    </StyledFooterAlerts>
  );
}

export default MainFooterAlertsView;
